import React from "react";
import { Link } from "react-router-dom";
import { SERVICES } from "@/lib/api";
import { ArrowRight } from "@phosphor-icons/react";

export default function Services() {
  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20" data-testid="services-page">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16">
        <div className="md:col-span-8">
          <p className="label-eyebrow">All Services</p>
          <h1 className="font-display text-5xl md:text-7xl font-black tracking-tighter leading-[0.9] mt-3">
            The Plaza,<br/>service by service.
          </h1>
        </div>
        <p className="md:col-span-4 text-black/60 self-end">
          Pick a service to book. All accounts share a single wallet across the plaza — earn credits in the gym, spend them at the spa.
        </p>
      </div>

      <div className="border-t border-black/10">
        {SERVICES.map((s, idx) => (
          <Link
            key={s.key}
            to={`/services/${s.key}`}
            data-testid={`services-row-${s.key}`}
            className="group grid grid-cols-12 gap-6 items-center border-b border-black/10 py-8 px-2 hover:bg-black hover:text-white transition-colors"
          >
            <span className="col-span-1 font-mono text-sm opacity-50">{String(idx + 1).padStart(2, "0")}</span>
            <div className="col-span-12 md:col-span-3">
              <h3 className="font-display text-2xl md:text-3xl font-black tracking-tight">{s.name}</h3>
            </div>
            <div className="col-span-12 md:col-span-5 text-sm opacity-80">{s.description}</div>
            <div className="col-span-12 md:col-span-2 hidden md:block">
              <img src={s.image} alt="" className="w-full h-16 object-cover" loading="lazy" />
            </div>
            <div className="col-span-12 md:col-span-1 flex justify-end">
              <ArrowRight size={20} className="group-hover:translate-x-1 transition" />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
